'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    body{\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n    }\n'], ['\n    body{\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n    }\n']);

var _styledComponents = require('styled-components');

var _fontFace = require('./fonts/font-face');

var _fontFace2 = _interopRequireDefault(_fontFace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/*
    // We should use fontfaceobserver directly inside the project instead of using createGlobalStyle
    // import FontFaceObserver from 'fontfaceobserver';

    var montserratFont = new FontFaceObserver('Montserrat');
    var montserratBoldFont = new FontFaceObserver('Montserrat Bold');

    var openSansFont = new FontFaceObserver('Open Sans');
    var openSansItalicFont = new FontFaceObserver('Open Sans Italic');
    var openSansLightFont = new FontFaceObserver('Open Sans Light');
    var openSansSemiBoldFont = new FontFaceObserver('Open Sans Semi Bold');
    var openSansBoldFont = new FontFaceObserver('Open Sans Bold');
    var openSansExtraBoldfont = new FontFaceObserver('Open Sans Extra Bold');
*/

var GlobalFont = (0, _styledComponents.createGlobalStyle)(_templateObject, (0, _fontFace2.default)("montserrat", "Montserrat", "montserrat-regular"), (0, _fontFace2.default)("montserrat", "Montserrat Bold", "montserrat-bold"), (0, _fontFace2.default)("openSans", "Open Sans", "opensans-regular"), (0, _fontFace2.default)("openSans", "Open Sans Italic", "opensans-italic"), (0, _fontFace2.default)("openSans", "Open Sans Light", "opensans-light"), (0, _fontFace2.default)("openSans", "Open Sans Semi Bold", "opensans-semibold"), (0, _fontFace2.default)("openSans", "Open Sans Bold", "opensans-bold"), (0, _fontFace2.default)("openSans", "Open Sans Extra Bold", "opensans-extrabold"));

exports.default = GlobalFont;